import { useEffect, useState } from 'react';

const calc = (target) => {
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  return {
    d: Math.floor(diff / (1000 * 60 * 60 * 24)),
    h: Math.floor((diff / (1000 * 60 * 60)) % 24),
    m: Math.floor((diff / (1000 * 60)) % 60),
    s: Math.floor((diff / 1000) % 60),
  };
};

export default function Countdown({ target, accent = '#6c5ce7', labelColor = '#64748b' }) {
  const [t, setT] = useState(() => calc(target));

  useEffect(() => {
    const i = setInterval(() => setT(calc(target)), 1000);
    return () => clearInterval(i);
  }, [target]);

  const items = [
    { n: t.d, l: 'días' },
    { n: t.h, l: 'hrs' },
    { n: t.m, l: 'min' },
    { n: t.s, l: 'seg' },
  ];

  return (
    <div className="flex justify-center gap-3 sm:gap-6">
      {items.map((it) => (
        <div key={it.l} className="text-center min-w-[60px]">
          <div
            className="text-3xl sm:text-4xl font-bold tabular-nums"
            style={{ color: accent }}
          >
            {String(it.n).padStart(2, '0')}
          </div>
          <div
            className="text-[10px] sm:text-xs uppercase tracking-widest mt-1"
            style={{ color: labelColor }}
          >
            {it.l}
          </div>
        </div>
      ))}
    </div>
  );
}